(function(){
  'use strict';

  // Debug flag via ?swymDebug=1 or window.SWYM_DEBUG=true
  var debug = (function(){
    try { return !!(window.SWYM_DEBUG || (typeof location !== 'undefined' && /[?&]swymDebug=1/.test(location.search))); } catch(_) { return false; }
  })();
  function log(){ try { if(debug) console.log.apply(console, ['[Swym Widgets]'].concat([].slice.call(arguments))); } catch(_){} }

  // Header counter helpers
  function getCountNodes(){
    // Allow project to override via a single selector string
    var override = null; try { override = window.SWYM_WISHLIST_COUNT_SELECTOR; } catch(_) {}
    // Default to a broad selector list that matches all known header counters in this theme
    var defaultSel = '.js-wishlist-count, .m-wishlist-count, .wishlist-h-count, .wishlist-total-count, [data-wishlist-count]';
    var sel = override && String(override).trim() ? override : defaultSel;
    try { return Array.prototype.slice.call(document.querySelectorAll(sel)); } catch(_) { return []; }
  }
  function setHeaderCount(n){
    var nodes = getCountNodes();
    for(var i=0;i<nodes.length;i++){
      var el = nodes[i];
      try { el.textContent = String(n); } catch(_){}
      try { el.style.display = ''; } catch(_){}
      try {
        el.setAttribute('data-count', String(n));
        el.setAttribute('data-total', String(n));
        if(el.dataset){ el.dataset.count = String(n); el.dataset.total = String(n); }
      } catch(_){}
    }
    if(debug) log('Header count set to', n, 'nodes:', nodes.length);
  }

  // List prefix helpers
  function getListPrefix(){ try { return window.SWYM_LIST_PREFIX || null; } catch(_) { return null; } }
  function filterListsByPrefix(arr, prefix){ if(!prefix) return arr||[]; return (arr||[]).filter(function(l){ var name = (l && (l.name||l.Name||''))+''; return name.indexOf(prefix) === 0; }); }

  // Swym SDK readiness
  var swatRef = null;
  function onSwymReady(cb){
    if(window._swat){ swatRef = window._swat; try{ cb(window._swat); }catch(_){} return; }
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function(swat){ swatRef = swat; try{ cb(swat); }catch(_){} });
  }

  // Initialize Swym action buttons safely
  function initActionButtons(swat){ try { if(swat && typeof swat.initializeActionButtons === 'function') swat.initializeActionButtons('body'); } catch(_){} }

  // Update header count using Swym as source of truth
  function updateHeaderCount(swat){
    swat = swat || swatRef || window._swat;
    if(!swat) return; // SDK not loaded yet
    var lid = null; try { lid = localStorage.getItem('SWYM_ACTIVE_LID'); } catch(_){}
    var prefix = getListPrefix();
    if(debug) log('Updating header count (active LID:', lid||'none', 'prefix:', prefix||'none', ')');

    var staleCleared = false; // prevent infinite loop if lists keep returning no match
    function countFromLists(lists){
      var arr = Array.isArray(lists) ? lists : (lists && Array.isArray(lists.lists) ? lists.lists : []);
      var hadLists = arr.length;
      if(lid){
        var filtered = arr.filter(function(x){ return (x && (x.lid||x.id||x.LID)) === lid; });
        // If active lid produces no match but original had lists, treat stored LID as stale and drop it.
        if(filtered.length === 0 && hadLists > 0 && !staleCleared){
          try{ localStorage.removeItem('SWYM_ACTIVE_LID'); }catch(_){ }
          if(debug) log('Stale active LID removed; retrying header count without LID');
          lid = null; staleCleared = true;
          return countFromLists({ lists: arr });
        }
        arr = filtered;
      } else if(prefix){ arr = filterListsByPrefix(arr, prefix); }
      var total = 0;
      for(var i=0;i<arr.length;i++){
        var items = (arr[i] && (arr[i].items || arr[i].Items || arr[i].listItems || (arr[i].contents && arr[i].contents.items))) || [];
        total += Array.isArray(items) ? items.length : 0;
      }
      if(total === 0){
        tryWishlistCountFallback();
        return;
      }
      setHeaderCount(total);
      if(debug) log('Header count computed as', total, 'from', arr.length, 'lists');
    }
    function tryWishlistCountFallback(){
      if(!swat) { setHeaderCount(0); return; }
      var tried = 0; var done = false;
      function handle(val){ if(done) return; done = true; if(debug) log('wishlistCount fallback value', val); if(typeof val === 'number' && val > 0){ setHeaderCount(val); } else { perListFetchFallback(); } }
      function attempt(style){
        if(done) return; tried++;
        try{
          if(style===0 && typeof swat.wishlistCount === 'function'){ swat.wishlistCount(handle); return; }
          if(style===1 && typeof swat.wishlistCount === 'function'){ swat.wishlistCount({ callbackFn: handle }); return; }
          if(style===2 && typeof swat.wishlistCount === 'function'){ swat.wishlistCount({ successCb: handle }); return; }
        }catch(e){ if(debug) log('wishlistCount style', style, 'error', e); }
        if(tried < 3) attempt(tried); else perListFetchFallback();
      }
      attempt(0);
    }
    function perListFetchFallback(){
      if(!swat || typeof swat.api !== 'function'){ setHeaderCount(0); return; }
      swat.api({ method:'GET', path:'/api/lists' }).then(function(resp){
        var arr = Array.isArray(resp) ? resp : (resp && resp.lists) || [];
        var total = 0; var pending = 0; var finished = false;
        if(!arr.length){ setHeaderCount(0); return; }
        arr.forEach(function(l){
          var lidVal = l.lid||l.id||l.LID; if(!lidVal) return;
          pending++;
          swat.api({ method:'GET', path:'/api/lists/'+lidVal+'?includeListContents=true' })
            .then(function(detail){
              var items = (detail && (detail.items||detail.Items||(detail.contents&&detail.contents.items))) || [];
              total += Array.isArray(items)?items.length:0;
            })
            .catch(function(err){ if(debug) log('Per-list fetch error', lidVal, err); })
            .finally(function(){ pending--; if(pending===0 && !finished){ finished=true; setHeaderCount(total); if(debug) log('Per-list fallback total', total); } });
        });
      }).catch(function(err){ if(debug) log('perListFetchFallback lists error', err); setHeaderCount(0); });
    }

    if(typeof swat.api === 'function'){
      if(lid){
        swat.api({ method:'GET', path:'/api/lists/'+lid+'?includeListContents=true' })
          .then(function(list){ var items = (list && (list.items||list.Items)) || []; setHeaderCount(Array.isArray(items)?items.length:0); })
          .catch(function(){ swat.api({ method:'GET', path:'/api/lists?includeListContents=true' }).then(countFromLists).catch(function(){ /* ignore */ }); });
      } else {
        swat.api({ method:'GET', path:'/api/lists?includeListContents=true' }).then(countFromLists).catch(function(){ /* ignore */ });
      }
    } else if(swat.fetchLists){
      try { swat.fetchLists({ callbackFn: countFromLists }); } catch(_){}
    }
  }

  // Resolve active wishlist LID (supports prefix filtering, stored value fallback)
  function getActiveListLid(swat){
    swat = swat || window._swat || swatRef;
    return new Promise(function(resolve){
      var prefix = getListPrefix();
      var stored = null; try { stored = localStorage.getItem('SWYM_ACTIVE_LID'); }catch(_){ }
      var finish = function(lists){
        var arr = Array.isArray(lists) ? lists : (lists && Array.isArray(lists.lists) ? lists.lists : []);
        var pick = null;
        if(stored){ pick = arr.find(function(l){ return (l && (l.lid||l.id||l.LID)) === stored; }); }
        if(!pick){
          var filtered = prefix ? filterListsByPrefix(arr, prefix) : arr;
          // Prefer a list that has contents
            pick = (filtered.find(function(l){ var items = l && (l.items||l.listItems||l.contents && l.contents.items); return items && items.length; }) || filtered[0] || arr.find(function(l){ var items = l && (l.items||l.listItems||l.contents && l.contents.items); return items && items.length; }) || arr[0] || null);
        }
        var lid = pick && (pick.lid||pick.id||pick.LID) || stored || null;
        if(lid){ try { localStorage.setItem('SWYM_ACTIVE_LID', lid); }catch(_){ } }
        resolve(lid);
      };
      try {
        if(swat && typeof swat.api === 'function'){
          swat.api({ method:'GET', path:'/api/lists' }).then(finish).catch(function(){
            if(swat.fetchLists){ swat.fetchLists({ callbackFn: finish }); } else { resolve(stored); }
          });
        } else if(swat && swat.fetchLists){ swat.fetchLists({ callbackFn: finish }); } else { resolve(stored); }
      } catch(e){ resolve(stored); }
    });
  }

  // Debounced header refresh after interactions
  function scheduleHeaderRefresh(){
    if(!window._swat && !swatRef) return;
    try { updateHeaderCount(); } catch(_){ }
    setTimeout(function(){ try { updateHeaderCount(); } catch(_){} }, 600);
    setTimeout(function(){ try { updateHeaderCount(); } catch(_){} }, 1400);
    // Late retry to accommodate slower API propagation
    setTimeout(function(){ try { updateHeaderCount(); } catch(_){} }, 2400);
  }

  // New Swym PDP ATW button support (id: #swym-atw-pdp-button, classes: atw-button-added)
  function isAtwAdded(btn){ return btn && (btn.classList.contains('atw-button-added') || btn.classList.contains('swym-added')); }
  function extractAtwIdentifiers(btn){
    var out = { epi:null, du:null };
    if(!btn) return out;
    try {
      var ds = btn.dataset || {};
      out.epi = ds.epi || ds.variantid || ds.variantId || ds.variant || null;
      out.du = ds.du || ds.url || ds.productUrl || null;
    }catch(_){ }
    if(!out.epi){
      try { var vMatch = /[?&]variant=(\d+)/.exec(location.search); if(vMatch) out.epi = vMatch[1]; }catch(_){ }
    }
    if(!out.du){
      try { if(/\/products\//.test(location.pathname)) out.du = location.pathname; }catch(_){ }
    }
    if(out.du && /^https?:/.test(out.du)){
      try { out.du = new URL(out.du, location.origin).pathname; }catch(_){ }
    }
    if(out.du && out.du.charAt(0) !== '/') out.du = '/' + out.du.replace(/^\/+/, '');
    return out;
  }
  // Async variant id resolution when epi missing
  function resolveAtwVariantId(ids){
    return new Promise(function(resolve){
      if(ids.epi) return resolve(ids.epi);
      // 1) Form input[name="id"]
      try { var form = document.querySelector('form[action*="/cart"], form[action*="/cart/add"], form[action*="/cart/add.js"], form[action*="/cart/add"]'); if(form){ var iv = form.querySelector('input[name="id"][value]'); if(iv && iv.value){ return resolve(iv.value.trim()); } } }catch(_){ }
      // 2) URL variant param
      try { var vm = /[?&]variant=(\d+)/.exec(location.search); if(vm) return resolve(vm[1]); }catch(_){ }
      // 3) Product JSON fetch (/products/handle.js)
      if(ids.du){
        try {
          var handle = ids.du.split('/products/')[1]; if(handle){ handle = handle.split('?')[0]; }
          if(handle){
            fetch('/products/' + handle + '.js').then(function(r){ return r.ok ? r.json() : Promise.reject(); }).then(function(p){
              var sel = null;
              // If URL variant param existed earlier but not matched, find matching variant
              try { var urlVar = /[?&]variant=(\d+)/.exec(location.search); if(urlVar){ sel = (p.variants||[]).find(function(v){ return String(v.id) === urlVar[1]; }); } }catch(_){ }
              if(!sel && Array.isArray(p.variants) && p.variants.length === 1) sel = p.variants[0];
              if(!sel && Array.isArray(p.variants)) sel = p.variants[0];
              if(sel && sel.id) return resolve(String(sel.id));
              throw new Error('No variant in product JSON');
            }).catch(function(){ fallbackListLookup(); });
            return; // wait async
          }
        }catch(_){ }
      }
      fallbackListLookup();
      function fallbackListLookup(){
        // 4) Active list items: match by du and take first epi
        var swat = window._swat || swatRef;
        if(!swat){ return resolve(null); }
        getActiveListLid(swat).then(function(lid){
          if(!lid || !swat.api){ return resolve(null); }
          swat.api({ method:'GET', path:'/api/lists/'+lid+'?includeListContents=true' }).then(function(list){
            var items = (list && (list.items||list.contents && list.contents.items)) || [];
            var match = items.filter(function(it){ return ids.du && (it.du === ids.du || (it.du||'').split('?')[0] === ids.du); });
            if(match.length === 1){ return resolve(String(match[0].epi || match[0].vi || match[0].id || match[0].EPI)); }
            if(match.length > 1){ return resolve(String(match[0].epi || match[0].vi || match[0].id || match[0].EPI)); }
            resolve(null);
          }).catch(function(){ resolve(null); });
        }).catch(function(){ resolve(null); });
      }
    });
  }
  // Fallback: explicitly add item to wishlist if Swym doesn't rebind add handler
  function addAtw(btn, ids){
    var swat = window._swat || swatRef; if(!swat) return;
    resolveAtwVariantId(ids).then(function(epi){
      if(!epi){ if(debug) log('ATW add aborted: could not resolve variant id'); return; }
      var payload = { epi: epi };
      if(ids.du) payload.du = ids.du;
      getActiveListLid(swat).then(function(lid){ if(lid) payload.lid = lid; proceed(payload); });
      function proceed(payload){
        var finish = function(){
          try { btn.classList.add('atw-button-added'); btn.classList.add('swym-added'); btn.setAttribute('aria-pressed','true'); }catch(_){ }
          try { var txt = btn.querySelector('.atw-button-text'); if(txt) txt.textContent = 'Added to Wishlist'; btn.setAttribute('aria-label','Remove from wishlist'); }catch(_){ }
          // Ensure SVG shows filled heart when added
          try {
            var svgIcon = btn.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon, svg');
            if(svgIcon){
              var path = svgIcon.querySelector('path');
              if(path){
                path.setAttribute('fill', 'currentColor');
                path.setAttribute('stroke', 'currentColor');
              }
            }
          }catch(_){ }
          try { updateHeaderCount(swat); }catch(_){ }
          scheduleHeaderRefresh();
          try { document.dispatchEvent(new CustomEvent('swym:lists-updated')); }catch(_){ }
          if(debug) log('ATW add done', payload);
        };
        try {
          if(typeof swat.addToWishList === 'function'){
            swat.addToWishList(payload, finish, finish);
          } else if(typeof swat.addToList === 'function' && payload.lid){
            swat.addToList({ lid: payload.lid, epi: payload.epi, du: payload.du, callbackFn: finish });
          } else { finish(); }
        }catch(e){ finish(); }
      }
    });
  }
  function removeAtw(btn, ids){
    var swat = window._swat || swatRef; if(!swat) return;
    resolveAtwVariantId(ids).then(function(epi){
      if(!epi){ if(debug) log('ATW removal aborted: could not resolve variant id'); return; }
      var payload = { epi: epi };
      if(ids.du) payload.du = ids.du;
      getActiveListLid(swat).then(function(lid){ if(lid) payload.lid = lid; proceed(payload); });
      function proceed(payload){
        var finish = function(){
          try { btn.classList.remove('atw-button-added'); btn.classList.remove('swym-added'); }catch(_){ }
          try { var txt = btn.querySelector('.atw-button-text'); if(txt) txt.textContent = 'Add to Wishlist'; btn.setAttribute('aria-label','Add to wishlist'); }catch(_){ }
          // Ensure ARIA pressed state reflects removal so subsequent add can work as expected
          try { btn.setAttribute('aria-pressed', 'false'); }catch(_){ }
          // Ensure button is interactive again
          try { btn.removeAttribute('disabled'); btn.style.pointerEvents = ''; }catch(_){ }
          try {
            var inner = btn.querySelector('button, [role="button"]');
            if(inner){ inner.removeAttribute('disabled'); inner.setAttribute('aria-pressed','false'); }
          }catch(_){ }
          // Update SVG fill to none when removed
          try {
            var svgIcon = btn.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon, svg');
            if(svgIcon){
              var path = svgIcon.querySelector('path');
              if(path){
                path.setAttribute('fill', 'none');
                path.setAttribute('stroke', 'currentColor');
              }
            }
          }catch(_){ }
          try { updateHeaderCount(swat); }catch(_){ }
          scheduleHeaderRefresh();
          try { document.dispatchEvent(new CustomEvent('swym:lists-updated')); }catch(_){ }
          // Re-initialize Swym action buttons shortly after removal to ensure the add flow is rebound
          try { setTimeout(function(){ try { initActionButtons(swat); } catch(_){} }, 60); }catch(_){ }
          if(debug) log('ATW removal done', payload);
        };
        try {
          if(typeof swat.removeFromWishList === 'function'){
            swat.removeFromWishList(payload, finish, finish);
          } else if(typeof swat.removeFromList === 'function' && payload.lid){
            swat.removeFromList({ lid: payload.lid, epi: payload.epi, du: payload.du, callbackFn: finish });
          } else { finish(); }
        }catch(e){ finish(); }
      }
    });
  }
  document.addEventListener('click', function(ev){
    var atwBtn = ev.target.closest && ev.target.closest('#swym-atw-pdp-button');
    if(!atwBtn) return;
    if(isAtwAdded(atwBtn)){
      ev.preventDefault();
      var ids = extractAtwIdentifiers(atwBtn);
      if(debug) log('ATW button clicked (remove flow)', ids);
      removeAtw(atwBtn, ids);
    } else {
      // Let Swym handle add; schedule header refresh
      if(debug) log('ATW button clicked (add flow)');
      var ids2 = extractAtwIdentifiers(atwBtn);
      setTimeout(scheduleHeaderRefresh, 300);
      setTimeout(scheduleHeaderRefresh, 1200);
      // Fallback: if not added shortly after click, explicitly add via SDK
      setTimeout(function(){
        try {
          if(!isAtwAdded(atwBtn)){
            if(debug) log('ATW add fallback invoked');
            addAtw(atwBtn, ids2);
          }
        } catch(_){ }
      }, 500);
    }
  }, true);

  // MutationObserver: refresh header count when Swym toggles classes and update SVG fill
  try {
    var mo = new MutationObserver(function(muts){
      var shouldRefresh = false;
      for(var i=0;i<muts.length;i++){
        var m = muts[i];
        if(m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'aria-pressed')){
          var tgt = m.target;
          if(tgt && tgt.classList && (tgt.classList.contains('swym-add-to-wishlist') || tgt.classList.contains('swym-button') || tgt.classList.contains('swym-wishlist-button') || tgt.id === 'swym-atw-pdp-button')){
            // Check if swym-added class was just added (indicates item added to wishlist)
            var wasAdded = tgt.classList.contains('swym-added') || tgt.classList.contains('atw-button-added');
            var wasRemoved = !wasAdded && (m.oldValue && (m.oldValue.indexOf('swym-added') >= 0 || m.oldValue.indexOf('atw-button-added') >= 0));
            
            // Update SVG fill based on added/removed state
            try {
              var btn = tgt.id === 'swym-atw-pdp-button' ? tgt : tgt.closest('#swym-atw-pdp-button');
              if(btn){
                var svgIcon = btn.querySelector('#swym-atw-pdp-button-icon, .atw-button-icon, svg');
                if(svgIcon){
                  var path = svgIcon.querySelector('path');
                  if(path){
                    if(wasAdded){
                      path.setAttribute('fill', 'currentColor');
                      path.setAttribute('stroke', 'currentColor');
                    } else if(wasRemoved){
                      path.setAttribute('fill', 'none');
                      path.setAttribute('stroke', 'currentColor');
                    }
                  }
                }
              }
            }catch(_){ }
            
            if(debug && wasAdded) log('Detected swym-added class change, refreshing count');
            shouldRefresh = true; break;
          }
        }
      }
      if(shouldRefresh){
        // Immediate update + debounced follow-ups
        try { updateHeaderCount(); } catch(_){}
        scheduleHeaderRefresh();
      }
    });
    mo.observe(document.documentElement, { subtree:true, attributes:true, attributeFilter:['class','aria-pressed'], attributeOldValue:true });
  } catch(_){ }

  // Fallback debug message if SDK missing after delay
  setTimeout(function(){ if(!window._swat && !swatRef && debug) log('Swym SDK not detected. Enable Swym app embed for wishlist.'); }, 2000);

  // Hook into Swym readiness
  onSwymReady(function(swat){
    if(debug) log('Swym SDK ready');
    initActionButtons(swat);
    updateHeaderCount(swat);
    // Recompute after a short delay (in case lists still populating)
    setTimeout(function(){ updateHeaderCount(swat); }, 1000);
    document.addEventListener('swym:lists-updated', function(){
      if(debug) log('swym:lists-updated event caught, updating count');
      updateHeaderCount(swat);
    });

    // If Swym signals a button was removed, ensure our PDP button can re-add
    try {
      document.addEventListener('swym:button-removed', function(){
        try { initActionButtons(swat); } catch(_){ }
        try {
          var b = document.getElementById('swym-atw-pdp-button');
          if(b){ b.setAttribute('aria-pressed','false'); b.removeAttribute('disabled'); }
        } catch(_){ }
      });
    } catch(_){ }

    // Add click listener to all Swym wishlist buttons to trigger count update after operation
    document.addEventListener('click', function(e){
      try {
        var btn = e.target.closest('.swym-button, .swym-add-to-wishlist, .swym-wishlist-button, [class*="swym"]');
        if(!btn) return;
        if(debug) log('Swym button clicked, scheduling count update');
        // Schedule multiple updates to catch the change
        setTimeout(function(){ try{ updateHeaderCount(swat); }catch(_){} }, 200);
        setTimeout(function(){ try{ updateHeaderCount(swat); }catch(_){} }, 800);
        setTimeout(function(){ try{ updateHeaderCount(swat); }catch(_){} }, 1500);
      } catch(_){}
    }, true);
  });

  // Attempt a late count update even if callbacks failed (defensive)
  setTimeout(function(){ updateHeaderCount(); }, 4000);

  // Add lightweight lock to avoid rapid double header refreshes
  var refreshLock = false;
  function safeSchedule(){ if(refreshLock) return; refreshLock = true; scheduleHeaderRefresh(); setTimeout(function(){ refreshLock=false; }, 500); }

  // Hook native Swym events (multiple event names for compatibility)
  try {
    document.addEventListener('swym:item-added', safeSchedule);
    document.addEventListener('swym:item-removed', safeSchedule);
    document.addEventListener('swym:wishlist-updated', safeSchedule);
    document.addEventListener('swym:button-added', safeSchedule);
    document.addEventListener('swym:button-removed', safeSchedule);
  }catch(_){ }

  // Listen for Swym internal events via window.SwymCallbacks
  try {
    if(window._swat || swatRef){
      var swat = window._swat || swatRef;
      // Hook into Swym's event system if available
      if(swat.eventEmitter && typeof swat.eventEmitter.on === 'function'){
        swat.eventEmitter.on('addToWishList', safeSchedule);
        swat.eventEmitter.on('removeFromWishList', safeSchedule);
      }
    }
  }catch(_){ }

  // Minimal public API exposure (optional)
  try { window.swymWidgets = window.swymWidgets || { updateHeaderCount: updateHeaderCount, scheduleHeaderRefresh: scheduleHeaderRefresh }; } catch(_){ }
  // Dump utility
  try { window.swymWidgets = window.swymWidgets || {}; window.swymWidgets.dump = function(){
    var sw = window._swat||swatRef; if(!sw){ console.log('Swym not ready'); return; }
    sw.api({ method:'GET', path:'/api/lists?includeListContents=true' }).then(function(r){ console.log('Raw lists', r); });
  }; }catch(_){ }
})();
